import FilterDate from '@/Enums/FilterDate.enum';
import { ShortcutItem } from '@/Interfaces/ShortcutItem.interface';
import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { PickersShortcutsProps } from '@mui/x-date-pickers';
import { DateRange } from '@mui/x-date-pickers-pro';
import { Moment } from 'moment';

interface IProps extends Omit<PickersShortcutsProps<DateRange<Moment> | null>, 'items'> {
  shortcutValue?: string;
  setShortcutToCustom?: () => void;
  className?: string;
  items?: ShortcutItem[];
}

const Shortcuts = ({
  items,
  onChange,
  isValid,
  changeImportance,
  setShortcutToCustom,
  shortcutValue,
  className,
}: IProps) => {
  if (items == null || items.length === 0) {
    return null;
  }

  const resolvedItems = items.map(item => {
    const newValue = item.getValue({ isValid });

    return {
      label: item.label,
      value: item.value,
      onClick: () => {
        if (item.value === FilterDate.CUSTOM_RANGE) {
          setShortcutToCustom?.();
          return;
        }
        onChange(newValue, changeImportance ?? 'accept', item);
      },
    };
  });

  return (
    <>
      <RadioGroup
        className={className}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '12px',
          borderRight: '1px solid rgb(0 0 0 / 0.12)',
        }}
        value={shortcutValue}
      >
        {resolvedItems.map(item => {
          return (
            <FormControlLabel
              value={item.value}
              key={item.value}
              sx={{
                margin: 0,
                width: '100%',
              }}
              label={undefined}
              control={
                <Radio
                  sx={{
                    borderRadius: '8px',
                    margin: 0,
                    width: '100%',
                    justifyContent: 'flex-start',
                    height: '40px',
                    color: 'black',
                    '&.Mui-checked': {
                      backgroundColor: 'rgba(27, 67, 50, 0.12)',
                    },
                  }}
                  onClick={item.onClick}
                  checkedIcon={<Box>{item.label}</Box>}
                  icon={<Box>{item.label}</Box>}
                />
              }
            />
          );
        })}
      </RadioGroup>
    </>
  );
};

export default Shortcuts;
